import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { AccountPageHeader } from '../../account/components/AccountPageHeader';
import { ShippingAddressForm } from '../components/ShippingAddressForm';
import { useCreateShippingAddress } from '../shipping.services';
import type { CreateShippingAddressInput } from '../shipping.types';

export function ShippingAddressNewPage() {
  const navigate = useNavigate();
  const createMutation = useCreateShippingAddress();

  const handleSubmit = async (data: CreateShippingAddressInput) => {
    try {
      await createMutation.mutateAsync(data);
      toast.success('Shipping address added successfully');
      navigate('/account/addresses');
    } catch (error) {
      toast.error('Failed to add shipping address');
      console.error('Create address error:', error);
    }
  };

  const handleCancel = () => {
    navigate('/account/addresses');
  };

  return (
    <div className="w-full space-y-8">
      <AccountPageHeader
        title="Add New Address"
        description="Fill in the details below to add a new delivery location."
      />

      <div className="bg-white p-8 rounded-[2.5rem] border-[1.5px] border-gray-100">
        <ShippingAddressForm
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={createMutation.isPending}
        />
      </div>
    </div>
  );
}
